/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @author Jiri Moc <jiri.moc@outlook.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { Form } from "../shared/FormModel/FormModel";
import { SectionGroup } from "../shared/FormModel/elements/FormSectionGroup";
import { Section } from "../shared/FormModel/elements/FormSection";
import { Row } from "../shared/FormModel/elements/FormRow";
import { HTMLContent } from "../shared/FormModel/elements/FormHTMLContent";
import { FieldText } from "../shared/FormModel/elements/FormFieldText";
import { FieldLabel } from "../shared/FormModel/elements/FormFieldLabel";

export const form_predavaciProtokol = Form({
    id: "predavaci-protokol",
    version: "2020-07-r1",
    title: "Předávací protokol",
    icon: "package-variant",
    showInMenu: true
}, [
    SectionGroup({}, [
        Section({
            id: "1",
            title: "Prodejce"
        }, [
            Row({}, [
                // tslint:disable: max-line-length
                HTMLContent({}, (data) => <>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Předávající:
                        </h2>
                        Tomáš Zimmel<br />
                        Ledenická - Škarda 1252, Srubec, 370 06<br />
                        IČO: 74171364<br />
                        kontakt: 775 020 314, <a href="mailto:info@kuchynerondo.cz">info@kuchynerondo.cz</a>
                    </p>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Zastoupen při předávání:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Číslo (popis) zakázky:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                </>)
                // tslint:enable: max-line-length
            ]),
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "2",
            title: "Přebírající"
        }, [
            Row({}, [
                // tslint:disable: max-line-length
                HTMLContent({}, (data) => <>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Osoba / firma:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Adresa:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Zastoupení při převzetí:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                </>)
                // tslint:enable: max-line-length
            ]),
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "2",
            title: "Přebírající"
        }, [
            Row({}, [
                // tslint:disable: max-line-length
                HTMLContent({}, (data) => <>
                    <p style={{
                        marginTop: "10px",
                        lineHeight: "25px",
                        textAlign: "justify"
                    }}>
                        <h2>
                            Dne:
                        </h2>
                        &nbsp;<br />
                        byla předávajícímu předána sestava nábytku bez připomínek a v požadované kvalitě<br />
                        &nbsp;<br />
                        <h2>
                            Připomínky k montáži:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                        <h2>
                            Nedodané či chybějící části nábytku:
                        </h2>
                        &nbsp;<br />
                        &nbsp;<br />
                        &nbsp;<br />
                    </p>
                </>)
                // tslint:enable: max-line-length
            ]),
        ])
    ]),
    SectionGroup({}, [
        Section({
            id: "3",
            title: "Potvrzení převzetí"
        }, [
            Row({
                id: "datum-prevzeti"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Datum  převzetí"
                }),
                FieldText({
                    id: "datum-prevzeti"
                }),
            ]),
            Row({
                id: "podpis-predavajiciho"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Podpis předávajícího"
                }),
                FieldText({
                    id: "podpis-predavajiciho"
                }),
            ]),
            Row({
                id: "podpis-prebiraciho"
            }, [
                FieldLabel({
                    width: "1/3",
                    label: "Podpis přebírajícího"
                }),
                FieldText({
                    id: "podpis-prebiraciho"
                }),
            ]),
        ])
    ])
]);